// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1a7Fx","approved":"Status_approved__BZPSo","rejected":"Status_rejected__1Jr53","expired":"Status_expired__gyb89","label":"Status_label__ooWc_"};